import { BASE_URL, COUNTRY } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICountry, ICountryInput } from "models/country";

export async function getCountries(params: string = ""):Promise<ICountry[] > {
  const response = await axios.get(BASE_URL + COUNTRY + params);
  return response.data;
}
export async function addCountry(data: ICountryInput) {
  const response = await axios.post(BASE_URL + COUNTRY, data);
  return response.data;
}
export async function editCountry(data: ICountryInput, id: string) {
  const response = await axios.put(BASE_URL + COUNTRY + "/" + data.code + '?id='+id, data);
  return response.data;
}

export async function deleteCountry(code: string,id:string) {
  const response = await axios.delete(BASE_URL + COUNTRY + "/" + id);
  return response.data;
}

export const CountryCells: HeadCell[] = [
  {
    id: "code",
    numeric: false,
    disablePadding: false,
    label: "T_country_code",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

